// @ts-nocheck
import useCurrentShipTosDataView from "@store/Framework/Common/Hooks/useCurrentShipTosDataView";
import useCheckboxPicker from "@store/Library/Components/Reporting/ModalPicker/useCheckboxPicker";

const useShipToPicker = (
    updateCallBack: (selectedItems: string[]) => void,
    externalSelectedCustomerSequence?: string[],
) => {
    const shipTos = useCurrentShipTosDataView();
    const { toggleItem, toggleAllItems, setSelectedItems, selectedItems } = useCheckboxPicker();

    const getShipToNameByCustomerSequence = (customerSequence: string) => {
        const customer = shipTos?.value?.find(shipTo => shipTo.customerSequence === customerSequence);
        return `${customer?.address1} ${customer?.address2} (${customer?.customerSequence})`;
    };

    const getCustomerSequenceByDisplayName = (displayName: string) => {
        const customer = shipTos?.value?.find(
            shipTo => `${shipTo?.address1} ${shipTo?.address2} (${shipTo?.customerSequence})` === displayName,
        );
        return customer?.customerSequence;
    };

    const updateSelectedCustomersByDisplayNames = (selectedItems: string[]) => {
        const selectedIds = selectedItems
            .map(getCustomerSequenceByDisplayName)
            .filter((id): id is string => id !== undefined);
        updateCallBack(selectedIds);
        // dispatch(updateSearchFields({ customerSequences: selectedIds.join(",") }));
    };

    const handleItemToggle = (item: string) => {
        const newSelectedItems = toggleItem(item);
        updateSelectedCustomersByDisplayNames(newSelectedItems);
    };

    const handleToggleAllItems = (items: string[]) => {
        const newSelectedItems = toggleAllItems(items);
        updateSelectedCustomersByDisplayNames(newSelectedItems);
    };
    const shipToDisplayNames =
        shipTos?.value
            // optimizely creates a shipTo with customerSequence -1 for the "show all" option so we need to filter it out
            ?.filter(shipTo => shipTo.customerSequence !== "-1")
            .map(shipTo => getShipToNameByCustomerSequence(shipTo.customerSequence)) || [];
    const selectedCustomerSequenceNames = externalSelectedCustomerSequence?.map(getShipToNameByCustomerSequence);

    if (
        selectedCustomerSequenceNames &&
        externalSelectedCustomerSequence &&
        selectedItems &&
        selectedItems.toString() !== selectedCustomerSequenceNames?.toString()
    ) {
        setSelectedItems(selectedCustomerSequenceNames);
    }

    return {
        handleItemToggle,
        handleToggleAllItems,
        shipToDisplayNames,
        selectedCustomerSequenceNames,
    };
};

export default useShipToPicker;
